import Swiper from "swiper";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

/* MENU */
(() => {
  const BREAKPOINT = 1024;
  const isMobile = () => window.innerWidth < BREAKPOINT;

  const nav = document.querySelector(".wp-block-navigation");
  const header = document.querySelector("header");
  const burgerBtn = nav?.querySelector(
    ".wp-block-navigation__responsive-container-open",
  );
  const container = nav?.querySelector(
    ".wp-block-navigation__responsive-container",
  );
  const adminBar = document.getElementById("wpadminbar");

  if (!nav || !burgerBtn || !container || !header) return;

  // Calcola il top del menu = admin bar + header
  const getMenuTop = () => {
    const adminBarH = adminBar ? adminBar.getBoundingClientRect().height : 0;
    const headerH = header.getBoundingClientRect().height;
    return adminBarH + headerH;
  };

  const applyMenuTop = () => {
    container.style.top = `${getMenuTop()}px`;
  };

  // Sposta il container nel body per posizionamento libero
  const relocate = () => {
    if (isMobile()) {
      if (container.parentNode !== document.body) {
        document.body.appendChild(container);
        applyMenuTop();
      }
    } else {
      if (container.parentNode !== nav) {
        nav.appendChild(container);
        container.style.top = "";
      }
    }
  };

  // Apri/chiudi menu
  const closeMenu = () => {
    container.classList.remove("is-menu-open");
    header.classList.remove("is-menu-open");
    burgerBtn.setAttribute("aria-expanded", "false");
  };

  const openMenu = () => {
    applyMenuTop();
    container.classList.add("is-menu-open");
    header.classList.add("is-menu-open");
    burgerBtn.setAttribute("aria-expanded", "true");
  };

  burgerBtn.addEventListener("click", () => {
    container.classList.contains("is-menu-open") ? closeMenu() : openMenu();
  });

  // Chiudi pulsante X interno al container
  const closeBtn = container.querySelector(
    ".wp-block-navigation__responsive-container-close",
  );
  closeBtn?.addEventListener("click", closeMenu);

  // Sottomenu su mobile
  nav.querySelectorAll("li.wp-block-navigation-submenu").forEach((item) => {
    item.addEventListener("click", (e) => {
      if (!isMobile()) return;

      const link = item.querySelector("a.wp-block-navigation-item__content");
      if (link?.contains(e.target)) e.preventDefault();
      e.stopPropagation();

      const isOpen = item.classList.contains("is-submenu-open");
      document
        .querySelectorAll("li.wp-block-navigation-submenu.is-submenu-open")
        .forEach((el) => {
          if (el !== item) el.classList.remove("is-submenu-open");
        });

      item.classList.toggle("is-submenu-open", !isOpen);
    });
  });

  // Chiudi cliccando fuori
  document.addEventListener("click", (e) => {
    if (!isMobile()) return;
    if (!container.contains(e.target) && !burgerBtn.contains(e.target)) {
      closeMenu();
    }
  });

  // --- Elementi da spostare nel menu su mobile ---
  const elementsToMove = Array.from(
    document.querySelectorAll(".header-moves-to-mobile"),
  );

  const placeholders = elementsToMove.map((el) => {
    const ph = document.createComment("header-moves-to-mobile-placeholder");
    el.parentNode.insertBefore(ph, el);
    return ph;
  });

  const menuInner = container.querySelector(
    ".wp-block-navigation__responsive-container-content",
  );

  const relocateExtraElements = () => {
    elementsToMove.forEach((el, i) => {
      if (!placeholders[i]) return;
      if (isMobile()) {
        if (el.parentNode !== menuInner) menuInner.appendChild(el);
      } else {
        if (el.parentNode !== placeholders[i].parentNode) {
          placeholders[i].parentNode.insertBefore(el, placeholders[i]);
        }
      }
    });
  };
  // --- Fine elementi da spostare ---

  // Resize
  window.addEventListener("resize", () => {
    relocate();
    relocateExtraElements();
    if (!isMobile() && container.classList.contains("is-menu-open")) {
      closeMenu();
    }
  });

  // Init
  relocate();
  relocateExtraElements();
})();
/* END MENU */
/* SOCIAL BAR */
(() => {
  const socialBar = document.querySelector(".header-social-bar");
  if (!socialBar) return;

  window.addEventListener("scroll", () => {
    socialBar.style.display = window.scrollY > 0 ? "none" : "";
  });
})();
/* END SOCIAL BAR */
